import React from 'react';
import { Stack } from '@adc/parallax-component-library';
// more informations: https://www.chromium.org/developers/design-documents/create-amazing-password-forms/
const FormContainer = ({ children, hasBigGaps = false, hasHiddenUserInput = false, }) => {
    return (React.createElement("form", { onSubmit: (e) => e.preventDefault() },
        React.createElement(Stack, { display: "flex", flexDirection: "column", gap: hasBigGaps ? '$6' : '$4' }, children),
        hasHiddenUserInput ? (React.createElement("input", { hidden: true, id: "userName", name: "username", autoComplete: "username", defaultValue: "" })) : null));
};
FormContainer.displayName = 'FormContainer';
export { FormContainer };
